import { reloadCarousel } from './carousels.js';

class Actions {
    constructor() {
        this.bindDeleteItemFromBudget();
    }

    async getSuggestedElements(dataSuggested) {
        var that = this;
        $('#appointment-categories').empty();
        $('#collapseReasonMsg .categories-content').empty();
        $('.appointment-budget .budget-items').empty();
        $('.appointment-budget .budget-total-price').hide();
        $('.appointment-budget .b-body-empty').show();
        this.updateBudget();
        $.ajax({
            url: $('#url-base-lang').val()+$('#dealer').val()+"/"+"procesor/getSuggestedElements",
            data: dataSuggested,
            type:'POST',
            beforeSend: function() {
                $('#appointment-categories-loader .wrap-loader').show();
                $('#appointment-categories').hide();
                $('#appointment-categories-empty').hide();
                $('#collapseReason .appointment-budget').hide();
                $('#desplegate-reasons').removeData('col-lg-8').addClass('col-lg-12');
            },
            success: function(result){	
                $('#desplegate-reasons').addClass('col-lg-8').removeClass('col-lg-12');
                if(result != "-1") {
                    $('#collapseReason .appointment-budget').show();
                    $('.appointment-budget .budget-total-price').show();
                    that.fillCategoriesCarousel(JSON.parse(result))
                } else {
                    $('#appointment-categories-loader .wrap-loader').hide();
                    $('#appointment-categories').hide();
                    $('#appointment-categories-empty').show();
                    $('#desplegate-reasons').removeClass('col-lg-8').addClass('col-lg-12');
                }
                
            }
        });
        
    }

    fillCategoriesCarousel(data) {
        let that = this;
        let  categories = data.category;
        let element = '<div class="swiper-container swiper-form">';
        element += '<div class="swiper-wrapper">';

        if(categories) {
            categories.forEach(function(category, index) {
                let categoryItem = '<div class="swiper-slide">';
                categoryItem += '<div class="form-icon-btn-padding w-100">';
                categoryItem += '<button class="form-btn-icons appointment-type"' +
                'id="btn-category-' + category.id +  '" data-category="' + category.id +'" data-type="' + category.id + '">';
    
                categoryItem += '<div class="form-icon-content form-icon-content-appointment">';
    
                categoryItem += '<div class="" style="align-self: center;display: flex;justify-content: center;">';
                categoryItem += '<img src="' + category.icon_name + '" alt="Image Preview" style="display: block; width:55px; height:55px;"></div>';
    
                categoryItem += '<div class="form-btn-icons-text">';
                categoryItem += category.description;
                categoryItem += '</div>'; // form-btn-icons-text
    
                categoryItem += '</div>'; // form-icon-content
    
                categoryItem += '<div class="w-100 caret-block">';
                categoryItem += '<div class="category-caret text-center" id="category-caret-'+ category.id +'"></div>'
                categoryItem += '</div>'; // caret-block
    
                categoryItem += '</button>'; // button
                categoryItem += '</div>'; // form-icon-btn-padding
                categoryItem += '</div>'; // swiper-slide
    
                element += categoryItem;
    
                that.fillCategoryActions(category);
            });
        }
        
        element += '</div>'; // swiper-wrapper
        element += '</div>'; // swiper-container

        element += '<div class="swiper-button-next"></div>'; // arrows
        element += '<div class="swiper-button-prev"></div>'; // arrows

        $('#appointment-categories').append(element);
        $('#appointment-categories-loader .wrap-loader').hide();
        $('#appointment-categories').show();

        $("[data-toggle=popover]").each(function(i, obj) {
            $(this).popover({
                html: true,
                sanitize: false,
                trigger: $(document).width()<1000 ? 'manual' : 'hover',
            }).on('click', function(e) {
                $(this).popover('toggle');
            });
        });

        reloadCarousel();
        this.bindCategoryEvents();
    }

    fillCategoryActions(category) {
        let that = this;

        let categoryActionItem = '<div class="category-actions-container" id="category-actions-container-'+ category.id + '">';
        categoryActionItem += '<label class="category-title">';
        categoryActionItem += $('#action_select_option_text').val();
        categoryActionItem += '</label>'; // category-title

        categoryActionItem += '<div class="category-actions-container-box">';
        if(category.actions && category.actions.length>0) {
            categoryActionItem += '<div class="w-100 category-wrapper">';
            categoryActionItem += '<div class="category-action-box">';
            categoryActionItem += '<table class="table table-actions">';
            categoryActionItem += '<tbody>';
            
            category.actions.forEach(function(action, index) {
                let actionItem = '<tr class="action-row-'+ action.action_base_id +'">';
                let availableElements = action.elements ? ' available-elements' : '';
                let dataImporter = action.importer_id ? ' data-importer="'+ action.importer_id +'"' : '';
                actionItem += '<td>';
                actionItem += '<div class="checkboxContent">';
                actionItem += '<input type="checkbox" id="action-' + action.action_base_id + '-category-' + category.id + '" class="regular-checkbox actions-checkboxs' +  availableElements +'"' +
                    dataImporter + '" category="' + category.id +'" action="' + action.action_base_id + '" data-show-price="'+action.previous_appointment_price	+'">'; 
                actionItem += '<label for="action-' + action.action_base_id + '-category-' + category.id +'" id="action-label-' + action.action_base_id + '">';
                actionItem += '<span class="custom-lbl-cb">' + action.description + '</span>';
                actionItem += '</label>'; // label
                actionItem += '</div>'; // checkboxContent
                actionItem += '</td>'; // td

                actionItem += '<td class="table-row-icon text-right">';
                if(action.description_info && action.description_info!='') {
                    let descriptionInfo = action.description_info.replaceAll('"', "'");
                    descriptionInfo.trim();

                    actionItem += '<span type="button" class="action-popover"'+
                    'data-container="body" data-toggle="popover"' +
                    'data-placement="left"' +
                    'title="' + action.description + '"' + 
                    'data-html="true"' +
                    'data-content="' + descriptionInfo + '">' +
                    '<i class="fas fa-info-circle"></i>' +
                    '</span>';
                }

                let showPrice = action.previous_appointment_price;
                let actionElementItem = "";
                if(action.elements && action.elements.length>0) {
                    action.elements.forEach(function(actionElement, index) {                        
                        let price = that.toCurrency(actionElement.price);
                        if(showPrice === 0 || showPrice === '0') {
                            actionElement.price = 0;
                            actionElement.price_tax = 0;
                            price = $('#price_not_available').val();
                        }
                        actionElementItem += '<tr class="hiddenRow e-category-' + category.id + '-action-' + action.action_base_id + '"></td><td class="w-100" colspan="2"><div class="table-row-elements"><div class="empty-col"></div><div class="action-element-item" id="act-' + action.action_base_id +'-im-'+actionElement.importer_id+'-el-'+ actionElement.id + '">';
                        actionElementItem += '<input type="checkbox" class="elements-checkboxs" id="cat-' + category.id +'-act-' + action.action_base_id  + '-im-'+actionElement.importer_id+'-el-' + actionElement.id + '-type-' + actionElement.type +'" data-category="' + category.id + '"' +
                        ' data-action="' + action.action_base_id + '" element="' + actionElement.id + '" data-type="' + actionElement.type + '"' +
                        ' data-importer="' + actionElement.importer_id +'" data-show-price="'+showPrice+'"'+
                        ' data-price-tax="' + actionElement.price_tax + '" data-price="' + actionElement.price + '"/>';
                        actionElementItem += '<label class="w-100" for="cat-' + category.id +'-act-' + action.action_base_id  + '-im-'+actionElement.importer_id+'-el-' + actionElement.id + '-type-' + actionElement.type +'">';
                        actionElementItem += '<span class="custom-sub-lbl-cb">' + actionElement.name + '</span>';
                        actionElementItem += '<span class="custom-lbl-cb-price float-right">' + price + '</span>';
                        actionElementItem += '</label></div></td></div></tr>'; // action-element-item
                    });
                }

                actionItem += '</td>'; // td
                actionItem += '</tr>';

                actionItem += actionElementItem;

                categoryActionItem += actionItem;
            });

            categoryActionItem += '</tbody>'; // tbody
            categoryActionItem += '</table>'; // table
            categoryActionItem += '</div>'; // category-action-box
            categoryActionItem += '</div>'; // category-wrapper
            categoryActionItem += '<div class="overlay">&nbsp;</div>'; // overlay
        }
        categoryActionItem += '</div>';

        categoryActionItem += '</div>'; // category-actions-container

        $('.categories-content').append(categoryActionItem);
    }

    bindCategoryEvents() {
        //Rao
        var that = this;
        $('.appointment-type').on('click', function() {
            let categoryId = $(this).attr('data-type');
            let categoryText = $(this).text().trim();

            /*
            * 1. category and actions; 2. category and no actions; 3. + whatever
            */
            if($(this).hasClass('type-selected') && $('.categories-content #category-actions-container-'+categoryId+' .action-item').length>0) {
                if($('.categories-content #category-actions-container-'+categoryId).is(':visible')) {
                    that.removeActionCategory(categoryId);
                    that.removeCategoryFromTitle(categoryText);
                } else {
                    $(this).find('.form-icon-content').addClass('form-icon-content-no-radius');
                    that.showActionBox(categoryId);
                }
            } else if($(this).hasClass('type-selected') && !$('.categories-content #category-actions-container-'+categoryId+' .action-item').length>0) {
                that.closeAllActionBox(categoryId);
                that.removeCategoryFromTitle(categoryText);
                $(this).find('.form-icon-content').removeClass('form-icon-content-no-radius');
            } else if(!$(this).hasClass('type-selected') && $('#category-actions-container-'+categoryId).is(':visible')) {
                that.removeActionCategory(categoryId);
                that.removeCategoryFromTitle(categoryText);
                $(this).find('.form-icon-content').removeClass('form-icon-content-no-radius');
            } else {
                //show category actions
                $(this).find('.form-icon-content').addClass('form-icon-content-no-radius');
                that.showActionBox(categoryId);
            }

            $('#reason_id').val($(this).attr('data-type'));
        
            //show comment block
            $('#collapseReasonMsg').addClass('active');

            if($('#appointment_reason .question-mobile').is(':visible')) {
                $('#appointment_reason .form-question').hide();
                $('#appointment_reason .question-mobile').show();
                $('#appointment_reason .question-mobile .form-answer').show();
            } else {
                $('#appointment_reason .question-desktop').show();
            }
        });

        // Bind actions checkers
        $('.actions-checkboxs').on('change', function() {
            let checkbox = $(this);
            let categoryId = checkbox.attr('category');
            let actionId = checkbox.attr('action');
            let categoryText = $('#btn-category-'+categoryId+" .form-btn-icons-text").text().trim();
            var isCategoryActive = that.showCategoryActive(categoryId);

            if(isCategoryActive) {
                that.setCategoryToTitle(categoryText);
                $('#btn-category-'+categoryId).find('.form-icon-content').addClass('type-selected');
                $('#btn-category-'+categoryId).find('.form-icon-content').addClass('form-icon-content-no-bottom');
                $('#btn-category-'+categoryId).find('.form-icon-content').addClass('form-icon-content-no-radius');
                $('#btn-category-'+categoryId).find('.caret-block .category-caret').addClass('category-caret-active');
            } else {
                $('#btn-category-'+categoryId).find('.form-icon-content').removeClass('type-selected');
                $('#btn-category-'+categoryId).find('.form-icon-content').removeClass('form-icon-content-no-bottom');
                $('#btn-category-'+categoryId).find('.caret-block .category-caret').removeClass('category-caret-active');
                that.removeCategoryFromTitle(categoryText);
            }
            that.getCategoriesTitle(); //actual text
            
            if($('.summary').length>0) {
                $('#summary-cancel-changes').show();
            } else {
                // Form created
                if(that.getSelectedActions().length>0) {
                    $('#reason-comments-desktop').show();
                    $('#reason-discount-codes-desktop').show();
                    $('#appointment-reason-continue').show();
                    that.showComments(true);
                } else {
                    $('#reason-comments-desktop').hide();
                    $('#reason-discount-codes-desktop').hide();
                    $('#appointment-reason-continue').hide();
                    that.showComments(false);
                }  
            }

            if(checkbox.hasClass('available-elements')) {
                $('.e-category-' + categoryId +'-action-' +  actionId).removeClass('hiddenRow');
            }

            if (!checkbox.is(':checked')) {
                that.removeFromBudget(checkbox); // budget
                if(checkbox.hasClass('available-elements')) {
                    $('.e-category-' + categoryId +'-action-' +  actionId).addClass('hiddenRow');
                }
            } else {
                if(checkbox.hasClass('available-elements')) {
                    $('.e-category-' + categoryId +'-action-' +  actionId).removeClass('hiddenRow');
                } 
                that.addBudgetItem(checkbox);
            }
        });

        $('.elements-checkboxs').on('change', function() {
            let categoryId = $(this).attr('data-category');
            let actionId = $(this).attr('data-action');
            let categoryText = $('#btn-category-'+categoryId+" .form-btn-icons-text").text().trim();
            var isCategoryActive = that.showCategoryActive(categoryId);
            if(isCategoryActive) {
                that.setCategoryToTitle(categoryText);
                $('#btn-category-'+categoryId).find('.form-icon-content').addClass('type-selected');
                $('#btn-category-'+categoryId).find('.form-icon-content').addClass('form-icon-content-no-bottom');
                $('#btn-category-'+categoryId).find('.form-icon-content').addClass('form-icon-content-no-radius');
                $('#btn-category-'+categoryId).find('.caret-block .category-caret').addClass('category-caret-active');
            } else {
                $('#btn-category-'+categoryId).find('.form-icon-content').removeClass('type-selected');
                $('#btn-category-'+categoryId).find('.form-icon-content').removeClass('form-icon-content-no-bottom');
                $('#btn-category-'+categoryId).find('.caret-block .category-caret').removeClass('category-caret-active');
                that.removeCategoryFromTitle(categoryText);
            }
            that.getCategoriesTitle(); //actual text
            
            if($('.summary').length>0) {
                $('#summary-cancel-changes').show();
            } else {
                // Form created
                if(that.getSelectedActions().length>0) {
                    $('#reason-comments-desktop').show();
                    $('#reason-discount-codes-desktop').show();
                    $('#appointment-reason-continue').show();
                    that.showComments(true);
                } else {
                    $('#reason-comments-desktop').hide();
                    $('#reason-discount-codes-desktop').hide();
                    $('#appointment-reason-continue').hide();
                    that.showComments(false);
                }  
            }

            if($(this).hasClass('available-elements')) {
                $('.e-category-' + categoryId +'-action-' +  actionId).removeClass('hiddenRow');
            }

            if (!$(this).is(':checked')) {
                that.removeFromSubBudget($(this)); // budget
                if($(this).hasClass('available-elements')) {
                    $('.e-category-' + categoryId +'-action-' +  actionId).addClass('hiddenRow');
                }
            } else {
                if($(this).hasClass('available-elements')) {
                    $('.e-category-' + categoryId +'-action-' +  actionId).removeClass('hiddenRow');
                } 
                that.addBudgetSubItem($(this));
            }
        });
    }
    
    showComments(showEnable) {
        if(showEnable) {
            $('.comment-box').addClass('d-flex'); 
        } else {
            $('.comment-box').removeClass('d-flex');
        }
    }

    showActionBox(categoryId) {
        //HIDES
        $('.categories-content .category-actions-container').each(function(){
            if($(this).attr('id') != categoryId) {
                $(this).hide();
            }
        });
        $('.form-icon-btn-padding .category-caret').each(function(){
            $(this).hide();
            $(this).parent().prev().removeClass('form-icon-content-no-radius');
        });

        //SHOWS
        if($('.categories-content #category-actions-container-'+categoryId+" .category-action-box").length>0) {
            $('.form-icon-btn-padding #category-caret-'+categoryId).show();
            $('.form-icon-btn-padding #category-caret-'+categoryId).parent().prev().addClass('form-icon-content-no-radius');
            if($('.categories-content #category-actions-container-'+categoryId).is(":hidden")) {
                $('.categories-content #category-actions-container-'+categoryId).show();
                
                // In summary sometimes r actions checked
                $('#category-actions-container-'+categoryId+" .checkboxContent .actions-checkboxs").each(function() {
                    if($(this).attr('checked')) {
                        $('#btn-category-'+categoryId+" .caret-block #category-caret-"+categoryId).addClass('category-caret-active');
                        $('#btn-category-'+categoryId).find('.form-icon-content').addClass('form-icon-content-no-bottom');
                    }
                });
            } 
        } 
    }

    closeAllActionBox() {
        $('.categories-content .category-actions-container').each(function() {
            $(this).hide();
        });
        $('.form-icon-btn-padding .category-caret').each(function(){
            $(this).hide();
        });
    }

    removeActionCategory(categoryId) {
        $('.categories-content #category-actions-container-'+categoryId + ' .category-action-box .action-item').each(function() {
            $(this).find('input').prop("checked",false);
        });
        $('.categories-content #category-actions-container-'+categoryId).slideUp("slow", function(){
            $('.form-icon-btn-padding #category-caret-'+categoryId).hide();
        });
        $('#btn-category-'+categoryId).removeClass('type-selected');
    }

    removeCategoryFromTitle(categoryText) {
        var actualText = $('#reason_name').val();
        var actualArray = actualText.split(",");
        actualArray.forEach(function(text, index) {
            if(text.trim() === categoryText) {
                actualArray.splice(index, 1);
            }
        });
        var text = "";
        if(actualArray.length>0) {
            text = actualArray.join(", ");
        } else {
            text = "";
            $('#appointment_reason .question-row-collapse .form-answer').html($('#reason-title-default').val());
            $('#appointment_reason .question-row-collapse .form-answer').css('color','#333333');
        }
        $('#reason_name').val(text);
    }

    getCategoriesTitle() {
        if($('#reason_name').val()=='') {
            $('#form-answer-reason').css('color','#333333');
            $('#appointment_reason .question-row-collapse').hide();
            $('#appointment_reason .question-row-collapse .form-answer').html('');
            $('#reason-title-default').val();
        } else {
            $('#appointment_reason .question-row-collapse').show();
            $('#appointment_reason .question-row-collapse .form-answer').hide();
            $('#appointment_reason .question-row-collapse .form-answer').html($('#reason_name').val());
        }   
    }

    setCategoryToTitle(categoryName) {
        var actualText = $('#reason_name').val();
        var actualArray = [];
        if(actualText!='') {
            actualArray = actualText.split(",");
        }
        if(actualArray.length>0) {
            var actualArray = actualText.split(",");
            if(actualArray.indexOf(categoryName)<0) {
                actualArray.push(categoryName);
                var text = "";
                if(actualArray.length>1) {
                    text = actualArray.join(", ");
                } else {
                    text = categoryName;
                }
                $('#reason_name').val(text);
            } else {

            }
        } else {
            $('#reason_name').val(categoryName);
        }
    }

    // Show if the category is active
    showCategoryActive(categoryId) {
        var isActive = false;
        var that = this;
        $('.categories-content #category-actions-container-' + categoryId + " .table-actions").each(function() {
            var chechbox = $(this).find('.actions-checkboxs');
            if($(chechbox).is(':checked')) {
                isActive = true;
                //that.showBudgetBlock();
                return true;
            }
        });
        if(isActive) {
            //this.showBudgetBlock();
            return true;
        } else {
            if($('#collapseReason .appointment-options').is(':visible')) {
                //this.hideBudgetBlock();
            }
        }
        return false;
    }

    getSelectedActions() {
        let actions = [];
        if($('.swiper-form').length>0) {
            $('.swiper-form .appointment-type .form-icon-content').each(function() {
                if($(this).hasClass('type-selected')) {
                    let categoryId = $(this).parent().attr('data-category');
                    // Category has actions
                    if($('#category-actions-container-'+categoryId+ ' .category-wrapper').length>0) {    
                        $('#category-actions-container-'+categoryId+ ' .category-wrapper .regular-checkbox').each(function() {
                            let actionId = $(this).attr('action');
                            if($(this).is(':checked')) {
                                let action = $(this).attr('id');
                                let importer = $(this).attr('data-importer');
                                let description = $(this).parent().find('.custom-lbl-cb').text();
                                action = action.split('-')[1];
                                let actionArray = { action_base_id: action, importer_id: importer, description: description };
                                if($(this).hasClass('available-elements')) {
                                    let elements = [];
                                    $('.e-category-' + categoryId +'-action-' + actionId + ' .elements-checkboxs').each(function() {
                                        if($(this).is(':checked')) {
                                            let elementItem = { 
                                                id: $(this).attr('element'),
                                                type: $(this).attr('data-type'),
                                                units: 1, // default
                                                importer_id: $(this).attr('data-importer'),
                                            }
                                            elements.push(elementItem);
                                        }
                                    });
                                    if(elements.length>0) {
                                        actionArray.elements = elements;
                                    }
                                } 
                                
                                actions.push(actionArray);
                            }
                        });
                    }
                } 
            });
        } 
        return actions;
    }

    mustShowPrice() {
        var showPrice = false;
        $('.budget-item-action').each(function(i,l) {
            if ($(l).attr('data-show-price') == 1) {
                showPrice = true;
            }
        });
        return showPrice;
    }

    getPostActions() {
        let actions = [];
        if($('.swiper-form').length>0) {
            $('.swiper-form .appointment-type .form-icon-content').each(function() {
                if($(this).hasClass('type-selected')) {
                    let categoryId = $(this).parent().attr('data-category');
                    // Category has actions
                    if($('#category-actions-container-'+categoryId+ ' .category-wrapper').length>0) {    
                        $('#category-actions-container-'+categoryId+ ' .category-wrapper .regular-checkbox').each(function() {
                            let actionId = $(this).attr('action');
                            if($(this).is(':checked')) {
                                let action = $(this).attr('id');
                                let importer = $(this).attr('data-importer');
                                let description = $(this).parent().find('.custom-lbl-cb').text();
                                action = action.split('-')[1];
                                let actionArray = { action_base_id: action, description: description };
                                if(importer && importer != 0) {
                                    actionArray.importer_id = importer;
                                }
                                actionArray.categoryId = categoryId;
                                if($(this).hasClass('available-elements')) {
                                    let elements = [];
                                    $('.e-category-' + categoryId +'-action-' + actionId + ' .elements-checkboxs').each(function() {
                                        if($(this).is(':checked')) {
                                            let elementImporter = $(this).attr('data-importer');
                                            let elementItem = { 
                                                id: $(this).attr('element'),
                                                type: $(this).attr('data-type'),
                                                units: 1, // default
                                            }
                                            if(elementImporter && elementImporter != 0) {
                                                elementItem.importer_id = elementImporter;
                                            }
                                            elements.push(elementItem);
                                        }
                                    });
                                    if(elements.length>0) {
                                        actionArray.elements = elements;
                                    }
                                } 
                                actions.push(actionArray);
                            }
                        });
                    }
                } 
            });
        } else {
            if($('.summary').length>0) {
                $('.budget-items .category-container .action-summary').each(function() {
                    let importer = $(this).attr('importer');
                    let actionArray = { 
                        action_base_id: $(this).attr('id'), 
                        description: $(this).find('.action-description').text().trim()
                    };

                    if(importer && importer != 0) {
                        actionArray.importer_id = importer;
                    }
                    let elements = [];
                    $(this).find('.budget-element').each(function() {
                        let elementImporter = $(this).attr('data-importer');
                        let elementItem = { 
                            id: $(this).attr('data-element'),
                            type: $(this).attr('data-type'),
                            units: 1, // default
                        }
                        if(elementImporter && elementImporter != 0) {
                            elementItem.importer_id = elementImporter;
                        }
                        elements.push(elementItem);
                    });
                    if(elements.length>0) {
                        actionArray.elements = elements;
                    }
                    actions.push(actionArray);
                });
            }
        }
        return actions;
    }

    updateActionQuantity(element) {
        // mirar les que estan 
        if($(element).is(':checked')) {
            var categoryId = $(element).attr('category');
            var actionId = $(element).attr('action');
            var btnAdd = $('#category-actions-container-'+categoryId + " .action-row-"+actionId).find('.btn-action-quantity-add');
            this.addActionQuantity(btnAdd, false);
        } else {
            this.subtractActionQuantity(element);
        }
    }

    // Add one quantity to current action
    addActionQuantity(element, adding) {
        var value = parseInt($(element).parent().find('.action-quantity').val());
        if(value<= 100) {
            if(adding) {
                value += 1;
            }
            $(element).parent().find('.action-quantity').val(value);
            this.updateBudget(element);
            this.updateActionsContainer(element);
            this.addBudgetItem(element);
        }
    }

    // substract one quantity to current action
    subtractActionQuantity(element) {
        var value = parseInt($(element).parent().find('.action-quantity').val());
        if(value> 1) {
            value -= 1;
            $(element).parent().find('.action-quantity').val(value);
            this.updateBudget();
            this.updateActionsContainer();
            this.removeBudgetItem(element);
        }
    }

    // update bagdet container
    updateBudget() {
        if(this.getSelectedActions().length>0) {
            $('.budget-container .b-body-content').removeClass('d-none');
            $('.budget-container .b-body-empty').hide();
            $('#appointment-reason-continue').removeAttr("disabled");
            $('.budget-total-price').show();
            if (!this.mustShowPrice()){
                $('.budget-total-price').hide();
            }
        } else {
            $('.budget-container .b-body-content').addClass('d-none');
            $('.budget-container .b-body-empty').show();
            $('#appointment-reason-continue').attr('disabled', 'disabled');
        }
        this.updateBudgetFromNavbar();
    }

    // Add action
    addBudgetItem(element) {
        $('.budget-container .b-body-empty').hide();
        $('.budget-container .b-body-content').removeClass("d-none");
        element = $(element);
        var that = this;
        var added = false;
        var categoryId = element.attr('category') ? element.attr('category') : element.attr('data-category');
        var categoryTitle = $('#btn-category-' + categoryId).find('.form-btn-icons-text').html();
        var actionId = element.attr('data-action') ? element.attr('data-action') : element.attr('action');
        var importerId = element.attr('data-importer');
        var type = element.attr('data-type') ? element.attr('data-type') : '';
        var elementId = element.attr('element') ? element.attr('element') : '';
        var actionTitle = element.parent().find('.custom-lbl-cb').text().trim() ? element.parent().find('.custom-lbl-cb').text().trim() : element.parent().find('.custom-sub-lbl-cb').text().trim();

        var showPrice = element.attr('data-show-price');
        var priceTax = element.attr('data-price-tax') ? element.attr('data-price-tax') : element.attr('price-tax');
        var price = element.attr('data-price') ? element.attr('data-price') : element.attr('price');

        var totalPrice = parseFloat(priceTax);
        var priceTotalItem = this.toCurrency(totalPrice);
        var priceFormat = this.toCurrency(priceTax);
        if(!priceTax) {
            priceFormat = '';
        }

        //if is element
        if(element.attr('data-element') && (element).attr('data-element')!='') {
            // find parent to check
            $('#category-actions-container-'+categoryId).find('.action-row-'+ actionId + " input").prop("checked", true);
        }

        //first find if element is already in budget
        $('.budget-container .b-body-content .budget-item ').each(function() {
            let budgetCategoryId = $(this).parent().attr('category');
            // category already in budget
            if(budgetCategoryId == categoryId) {
                $('.category-'+categoryId+ " .item-container .budget-item-action").each(function() {
                    if($(this).attr('data-action') == actionId) {
                        $(this).find('.item-price').html(priceTotalItem);
                        added = true;
                        return true;
                    } 
                });
                if(!added) {
                    let item = '<div class="col-12 main-item row no-padding-margin budget-item-action item-action-' + actionId +'" action="'+actionId+'" element="' + elementId + '" data-type="' + type +'" data-show-price="'+showPrice+'">';
                    item += '<div class="w-100 budget-item-wrapper"><div class="w-100 d-flex"><div class="col-1 text-left no-padding-margin action-delete">';
                    item += '<button type="button" class="btn delete-item" category="' + categoryId + '" action="' + actionId + '" importer="' + importerId +'" element="' + elementId +'" data-type="' + type +'"><i class="fas fa-times"></i></button></div>';
                    item += '<div class="col-11 action-desc">'+  $.trim(actionTitle) + ' </div>';
                    item += '<div class="col-4 no-padding-margin text-right item-price" data-price-tax="'+ priceTax + '" data-price="'+ price + '">'+ priceFormat +'</div>';
                    item += '</div></div></div>';
                
                    $('.category-'+categoryId+ " .item-container").append(item);
                    that.bindDeleteItemFromBudget();
                    added = true;
                }
            } 
        });

        // new item to badget
        if(!added) {
            var itemHeader = '<div class="col-12 main-item row no-padding-margin category-container category-' + categoryId + '" category="'+categoryId+'">';
            itemHeader += '<div class="col-12 row no-padding-margin pt-1 pb-1 budget-item budget-item-header">';
            itemHeader += '<div class="col-12 budget-category-title no-padding-margin pr-1">'+ categoryTitle +'</div>';
            itemHeader += '</div>';

            var item = '<div class="col-12 row no-padding-margin item-container">';
            item += '<div class="col-12 row no-padding-margin budget-item-action item-action-' + actionId +'" action="'+actionId+'" element="' + elementId + '" data-type="' + type +'" data-show-price="'+showPrice+'">';
            item += '<div class="w-100 budget-item-wrapper"><div class="w-100 d-flex"><div class="col-1 text-left no-padding-margin action-delete">';
            item += '<button type="button" class="btn delete-item" category="' + 
            categoryId + '" action="' + actionId + '" importer="' + importerId +'" element="' + elementId + '" data-type="' + type +'"><i class="fas fa-times"></i></button></div>';
            item += '<div class="col-11 action-desc">'+  $.trim(actionTitle) + ' </div>';
            item += '<div class="col-4 no-padding-margin text-right item-price" data-price-tax="'+ priceTax + '" data-price="'+ price + '">'+ priceFormat  +'</div>';
            
            item += '</div></div></div></div>';
            item += '<div class="w-100 budget-separator"></div>';

            itemHeader += item;
            itemHeader += '</div>';
            $('.budget-items').append(itemHeader);
            this.bindDeleteItemFromBudget();
        }

        this.updateBudget();
        this.calculateTotal();
    }

    addBudgetSubItem(element) {
        $('.budget-container .b-body-empty').hide();
        $('.budget-container .b-body-content').removeClass("d-none");
        element = $(element);
        var that = this;
        var added = false;
        var actionAdded = false;
        var categoryId = element.attr('category') ? element.attr('category') : element.attr('data-category');
        var categoryTitle = $('#btn-category-' + categoryId).find('.form-btn-icons-text').html();
        var actionId = element.attr('data-action') ? element.attr('data-action') : element.attr('action');
        var importerId = element.attr('data-importer');
        var type = element.attr('data-type') ? element.attr('data-type') : '';
        var elementId = element.attr('element') ? element.attr('element') : '';
        var actionTitle = element.parent().find('.custom-lbl-cb').text().trim() ? element.parent().find('.custom-lbl-cb').text().trim() : element.parent().find('.custom-sub-lbl-cb').text().trim();

        var showPrice = $('#action-'+actionId+'-category-'+categoryId).attr('data-show-price');
        var priceTax = element.attr('data-price-tax') ? element.attr('data-price-tax') : element.attr('price-tax');
        var price = element.attr('data-price') ? element.attr('data-price') : element.attr('price');

        var totalPrice = parseFloat(priceTax);
        var priceTotalItem = this.toCurrency(totalPrice);
        var priceFormat = this.toCurrency(price);
        if(!priceTax) {
            priceFormat = '';
        } else if(priceTax === '0' || priceTax === 0) {
            priceFormat = $('#price_not_available').val();
        }

        //if is element
        if(element.attr('data-element') && (element).attr('data-element')!='') {
            // find parent to check
            $('#category-actions-container-'+categoryId).find('.action-row-'+ actionId + " input").prop("checked", true);
        }

        //first find if element is already in budget
        $('.budget-container .b-body-content .budget-item').each(function() {
            let budgetCategoryId = $(this).parent().attr('category');
            // category already in budget
            if(budgetCategoryId == categoryId) {
                $('.category-'+categoryId+ " .item-container .main-item item-action-" + actionId).each(function() {
                    if($(this).attr('data-action') == actionId) {
                        $(this).find('.item-price').html(priceTotalItem);
                        added = true;
                    } 
                });
                if(!added) {
                    // need to search if action is added
                    let item = '<div class="col-12 sub-item row no-padding-margin budget-item-action item-action-' + actionId +'" action="'+actionId+'" element="' + elementId + '" data-type="' + type +'" category="'+categoryId+'" data-show-price="'+showPrice+'">';
                        item += '<div class="col-2"></div><div class="col-1 text-left no-padding-margin action-delete">';
                        item += '<button type="button" class="btn delete-item-sub" category="' + 
                        categoryId + '" action="' + actionId + '" importer="' + importerId +'" element="' + elementId +'" data-type="' + type +'"><i class="fas fa-times"></i></button></div>';
                        item += '<div class="col-9 action-desc"><div class="item-desc">'+  $.trim(actionTitle) + '</div>';
                        item += '<div class="no-padding-margin text-right item-price" data-price-tax="'+ priceTax + '" data-price="'+ price + '">'+ priceFormat +'</div>';
                        item += '</div></div>';

                    if(that.findActionInBudget($(this).parent(), actionId)) {
                        $(this).parent().find('.item-action-' + actionId + ' .budget-item-wrapper').append(item);
                    } else {
                        $('.category-'+categoryId+ " .item-container").append(item);
                    }
                    that.bindDeleteSubItemFromBudget();
                    added = true;
                }
            } 
        });

        // new item to badget
        if(!added) {
            var itemHeader = '<div class="col-12 sub-item row no-padding-margin category-container category-' + categoryId + '" category="'+categoryId+'">';
            itemHeader += '<div class="col-12 row no-padding-margin pt-1 pb-1 budget-item budget-item-header">';
            itemHeader += '<div class="col-12 budget-category-title no-padding-margin pr-1">'+ categoryTitle +'</div>';
            itemHeader += '</div>';

            var item = '<div class="col-12 row no-padding-margin item-container">';
            item += '<div class="col-12 row no-padding-margin budget-item-action item-action-' + actionId +'" action="'+actionId+'" element="' + elementId + '" data-type="' + type +'" data-show-price="'+showPrice+'">';
            item += '<div class="col-2"></div><div class="col-1 text-left no-padding-margin action-delete">';
            item += '<button type="button" class="btn delete-item" category="' + 
            categoryId + '" action="' + actionId + '" importer="' + importerId +'" element="' + elementId + '" data-type="' + type +'"><i class="fas fa-times"></i></button></div>';
            item += '<div class="col-9 action-desc"><div class="item-desc">'+  $.trim(actionTitle) + ' </div>';
            item += '<div class="no-padding-margin text-right item-price" data-price-tax="'+ priceTax + '" data-price="'+ price + '">'+ priceFormat  +'</div>';
            
            item += '</div></div>';
            item += '<div class="w-100 budget-separator"></div>';

            itemHeader += item;
            itemHeader += '</div>';

            $('.category-'+categoryId+  '.item-action-' + actionId).append(itemHeader);
            this.bindDeleteSubItemFromBudget();
        }

        this.updateBudget();
        this.calculateTotal();
    }

    findActionInBudget(budgetItemContainer, actionId) {
        let found = false;
        $(budgetItemContainer).find('.item-container .budget-item-action').each(function() {
            if($(this).attr('action') == actionId) {
                found = true;
                return true;
            }
        });
        return found;
    }

    // Uncheck action
    removeFromBudget(element) {
        var categoryId = $(element).attr('data-category') ? $(element).attr('data-category') : $(element).attr('category');
        var actionId = $(element).attr('data-action') ? $(element).attr('data-action') : $(element).attr('action');
        var type = $(element).attr('data-type') ? $(element).attr('data-type') : '';
        var itemRow = $('.category-'+categoryId+' .item-container .item-action-'+actionId);
        if($(element).attr('element') && $(element).attr('element') != '') {
            var elementId = $(element).attr('element');
            var importer_id = $(element).attr('data-importer');
            
            $('.category-'+categoryId+' .item-container .budget-item-action').each(function() {
                if($(this).attr('element') === elementId && $(this).attr('data-type') === type) {
                    $(this).remove();
                }
            });

            $('#cat-'+categoryId+"-act-"+actionId+"-im-"+importer_id+"-el-"+elementId+"-type-"+type).prop("checked", false); // uncheck this
            var numberOfChecked = 0;
            $('.e-category-' + categoryId +'-action-' + actionId + ' input').each(function() {
                if($(this).is(':checked')) {
                    numberOfChecked += 1;
                }
            });
            if(numberOfChecked == 0) {
                $(itemRow).remove();
                $('#action-'+actionId+"-category-"+categoryId).prop("checked", false);
                $('.e-category-' + categoryId +'-action-' +  actionId).each(function() {
                    $(this).addClass('hiddenRow');
                });
            } 
        } else {
            $(itemRow).remove();
            $('#action-'+actionId+"-category-"+categoryId).prop("checked", false);
            $('.e-category-' + categoryId +'-action-' + actionId + ' input').each(function() {
                $(this).prop("checked", false);
            });

            if($('#action-' + actionId+ '-category-' + categoryId).hasClass('available-elements')) {
                $('.e-category-' + categoryId +'-action-' +  actionId).each(function() {
                    $(this).addClass('hiddenRow');
                })
            }  
        }

        // look out if exist any item in same categorty, and delete if
        var itemsFound = false;
        $('.category-'+categoryId+ " .item-container .budget-item-action").each(function() {
            itemsFound = true;
        });

        if(!itemsFound) {
            $('.budget-items .category-'+categoryId).remove();
            // Mirar si hem de desactivar la categoria
            $('#btn-category-'+categoryId).find('.form-icon-content').removeClass('type-selected');
            $('#btn-category-'+categoryId).find('.form-icon-content').removeClass('form-icon-content-no-bottom');
            $('#btn-category-'+categoryId).find('.form-icon-content').removeClass('form-icon-content-no-radius');
            $('#btn-category-'+categoryId).find('.caret-block .category-caret').removeClass('category-caret-active');
        }

        this.updateBudget();
        // recalculate totals and IVA
        this.calculateTotal();
    }

    removeFromSubBudget(element) {
        var categoryId = $(element).attr('data-category') ? $(element).attr('data-category') : $(element).attr('category');
        var actionId = $(element).attr('data-action') ? $(element).attr('data-action') : $(element).attr('action');
        var type = $(element).attr('data-type') ? $(element).attr('data-type') : '';
        if($(element).attr('element') && $(element).attr('element') != '') {
            var elementId = $(element).attr('element');
            var importer_id = $(element).attr('data-importer');
            let parents = $(element).parent().parent().attr('class');
            parents = parents.replaceAll(" ", ".");
            $("."  + parents).each(function() {
                if($(this).attr('category') === categoryId && $(this).attr('element') === elementId && $(this).attr('data-type') === type) {
                   $(this).remove();
                }
                
            });
            $('#cat-'+categoryId+"-act-"+actionId+"-im-"+importer_id+"-el-"+elementId+"-type-"+type).prop("checked", false); 
            
            // budget
            $('.budget-items .category-'+categoryId + " .sub-item").each(function() {
                if($(this).attr('category') === categoryId && $(this).attr('element') === elementId && $(this).attr('data-type') === type && $(this).attr('action') === actionId) {
                    $(this).remove();
                }
            });
        } 

        // look out if exist any item in same categorty, and delete if
        var itemsFound = false;
        $('.category-'+categoryId+ " .item-container .budget-item-action").each(function() {
            itemsFound = true;
        });

        if(!itemsFound) {
            $('.budget-items .category-'+categoryId).remove();
            $('.budget-items .category-'+categoryId).each(function() {
                $(this).remove();
            });
            // Mirar si hem de desactivar la categoria
            $('#btn-category-'+categoryId).find('.form-icon-content').removeClass('type-selected');
            $('#btn-category-'+categoryId).find('.form-icon-content').removeClass('form-icon-content-no-bottom');
            $('#btn-category-'+categoryId).find('.form-icon-content').removeClass('form-icon-content-no-radius');
            $('#btn-category-'+categoryId).find('.caret-block .category-caret').removeClass('category-caret-active');
        }

        // mirar si hi han items a la bossa, sino tancar lateral
        if($('.budget-items .category-container').length == 0) {
            // uncheck actions
            if($('#action-'+actionId+"-category-"+categoryId).is(':checked')) {
                $('#action-'+actionId+"-category-"+categoryId).prop("checked", false);
                $('#action-'+actionId+"-category-"+categoryId).trigger("change");
            } 
        }


        this.updateBudget();
        // recalculate totals and IVA
        this.calculateTotal();
    }

    // Calculate total import
    calculateTotal() {
        var totalPrice = 0;
        var totalTaxes = 0;
        var subTotalPrice = 0;
        $('.budget-container .budget-items .category-container .item-container .budget-item-action').each(function() {
            let itemPrice = $(this).find('.item-price').attr('data-price');
            let itemPriceTax =  $(this).find('.item-price').attr('data-price-tax');
            if(itemPrice !== "undefined") {
                totalPrice += parseFloat(itemPrice);
                totalTaxes += parseFloat(itemPriceTax);
            }
        });

        let trigger = 'hover';
        if($(document).width()<1000) {
            trigger = 'manual';
        }

        subTotalPrice = totalPrice;
        totalPrice = parseFloat(totalTaxes) - parseFloat(totalPrice);
        if(totalPrice == 0) {
            $('.budget-total-price .budget-price-total .value').html('<div class="not_price">-</div>');
            $('.budget-total-price .budget-price-subtotal .value').html("-");
            $('.budget-total-price .budget-price-tax .value').html("-");
        } else {
            $('.budget-total-price .budget-price-total .value').html(this.toCurrency(parseFloat(totalTaxes)));
            $('.budget-total-price .budget-price-subtotal .value').html(this.toCurrency(parseFloat(subTotalPrice)));
            $('.budget-total-price .budget-price-tax .value').html(this.toCurrency(parseFloat(totalPrice)));
        }
    }

    bindDeleteItemFromBudget() {
        var that = this;
        $('.delete-item').on('click', function() {
            that.removeFromBudget($(this));
        });
    }

    bindDeleteSubItemFromBudget() {
        var that = this;
        $('.delete-item-sub').on('click', function() {
            that.removeFromSubBudget($(this));
        });
    }

    // PENDING TO DO OR NOT
    updateActionsContainer(element) {
        //current action element value
        var value = parseInt($(element).parent().find('.action-quantity').val());
        var rowQuantity = $(element).parent();

        if(value>= 1) {
            var categoryId =  $(rowQuantity).attr('category');
            var checkbox = $('#action-'+ $(rowQuantity).attr('action') + "-" + 
            "category-" + categoryId);
            $(checkbox).attr("checked", true);
            
            $('#btn-category-'+ categoryId).find('.form-icon-content').addClass('form-icon-content-no-radius');
            $('#btn-category-'+categoryId).find('.form-icon-content').addClass('type-selected');
            $('#btn-category-'+categoryId).find('.form-icon-content').addClass('form-icon-content-no-bottom');
            $('#btn-category-'+categoryId).find('.caret-block .category-caret').addClass('category-caret-active');
        } 
    }

    // update navbar price
    updateBudgetFromNavbar() {
        $('#navbar-price').show();
        var totalPrice = this.getTotalPrice();
        if(window.innerWidth<1000) {
            $('.navbar-price-movile').show();
            $('.navbar-price-desktop').hide();
            $('.navbar-price-movile #navbar-price').show();
            $('.page-body').addClass('extra-padding-top');
        } else {
            $('.navbar-price-desktop').show();
            $('.navbar-price-movile').hide();
            $('.navbar-price-desktop #navbar-price').show();
            $('.page-body').removeClass('extra-padding-top');
        }
        if(totalPrice.totalPriceTax === 0) {
            $('.brand__navbar #navbar-price .prive-value').html('<span class="not_price"></span>');
        } else {
            $('.brand__navbar #navbar-price .prive-value').html(this.toCurrency(parseFloat(totalPrice.totalPriceTax)));
        }
    }

    getTotalPrice() {
        var totalPrice = 0;
        var totalPriceTax = 0;
        $('.budget-container .budget-items .category-container .item-container .budget-item-action').each(function() {
            var itemPrice =  $(this).find('.item-price').attr('data-price');
            var itemPriceTax =  $(this).find('.item-price').attr('data-price-tax');
            if(itemPrice !== "undefined") {
                totalPrice += (parseFloat(itemPrice));
                totalPriceTax += (parseFloat(itemPriceTax));
            }
        });
        return { totalPriceTax: totalPriceTax, totalPrice: totalPrice };
    }

    toCurrency(amount) {
        let decimals 	= $('#decimals').val();
        let thousands = $('#thousands').val();
        let symbol = $('#symbol').val();
        let symbolPrecede = $('#symbolPrecede').val();
        amount = $.number(amount, 2, decimals, thousands);

        if (symbolPrecede === "1") {
          return symbol + ' ' + amount;
        } else {
          return amount + ' ' + symbol;
        }
    }

    resetActions() {
        $('.budget-container .b-body .b-body-content .budget-items').empty();
        this.updateBudget();
    }

}

export default Actions;